import { isValidPhoneNumber } from "react-phone-number-input";
import * as yup from "yup";

export const contactUsSchema = yup.object().shape({
  lastname: yup.string().required("Last name is required"),
  firstname: yup.string().required("First name is required"),
  type: yup.string(),
  email: yup
    .string()
    .email("Must be a valid email")
    .required("Email is required"),

  

   applicationID: yup.string().when("type", {
    is: "in-app",
    then: yup.string().required("Application ID is required"),
    otherwise: yup.string(),
  }),

  message: yup.string().required("Message is required"),

  phone: yup
    .string()
    .required("Phone number is required")
    .test({
      name: "valid",
      message: "Phone number must be valid",
      test: function (value) {
        return value?.length == 14 && isValidPhoneNumber(value);
      },
    }),
});
